import type {RepoStackSummary} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_stacks'
import {AlertIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {clsx} from 'clsx'

import styles from './Stacks.module.css'

/** Shown on an open stack when a closed pull request blocks merging it. The server only sends one for open stacks. */
export function StackClosedPullWarning({
  closedPullRequest,
  className,
}: Pick<RepoStackSummary, 'closedPullRequest'> & {className?: string}) {
  if (!closedPullRequest) return null

  return (
    <p className={clsx(styles.warning, className)}>
      <AlertIcon size={12} className={styles.warningIcon} />
      <span>
        Unmergeable due to a closed PR{' '}
        <Link href={closedPullRequest.url} className={styles.warningLink} inline>
          #{closedPullRequest.number}
        </Link>
      </span>
    </p>
  )
}
